import React, { useEffect, useState } from "react";
import { server } from "../server";
import axios from "axios";
import useAuth from "../useAuth";
import LoadingComponent from "../Components/LoadingComponent";

export default function Homepage() {
  const token = localStorage.getItem("janToken");
  const { department } = useAuth();

  const [loading, setLoading] = useState(false);
  const [allDepartments, setAllDepartments] = useState([]);
  const [filteredAllDepartments, setFilteredAllDepartments] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState("");
  const [switchUserData, setSwitchUserData] = useState("");
  const [selectedSwitchDepartments, setSelectedSwitchDepartments] = useState(
    []
  );

  // Fetch All Departments
  const fetchDepartments = async () => {
    try {
      setLoading(true);
      const { data } = await axios.get(
        `${server}/grievance/department/getAllDepartments`,
        {
          headers: { Authorization: `Bearer ${token}` },
          params: {
            pageNo: 1,
            pageSize: 1000,
            admin: true,
          },
        }
      );
      setAllDepartments(data?.data);
      setFilteredAllDepartments(data?.data);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  // Fetch accessible users for selected department
  const fetchSwitchUsersList = async () => {
    setSelectedSwitchDepartments([]);
    setSwitchUserData([]);
    try {
      setLoading(true);
      const { data } = await axios.get(`${server}/switchUsersList/getById`, {
        headers: { Authorization: `Bearer ${token}` },
        params: {
          departmentId: selectedDepartment?.id,
        },
      });
      const list = data?.data?.accessibleDepartmentsList || [];
      setSwitchUserData(data?.data);

      setLoading(false);
      //reselect dept IDs
      const preselectedIds = list.map((d) => d.deptId);
      setSelectedSwitchDepartments(preselectedIds);
    } catch (error) {
      console.log(error);
      // alert(error?.response?.data?.message || error?.response?.data);
    } finally {
      setLoading(false);
    }
  };

  // Search department
  const filterDepartment = (e) => {
    let search = e.target.value;
    if (search) {
      const res = allDepartments?.filter((elem) =>
        elem.departmentName.toLowerCase().includes(search.toLowerCase())
      );
      setFilteredAllDepartments(res);
    } else {
      setFilteredAllDepartments(allDepartments);
    }
  };

  // Toggle switch department selection
  const toggleSwitchDepartment = (deptId) => {
    setSelectedSwitchDepartments((prev) =>
      prev.includes(deptId)
        ? prev.filter((id) => id !== deptId)
        : [...prev, deptId]
    );
  };

  // Submit selected departments
  const submitSelectedDepartments = async () => {
    if (selectedSwitchDepartments?.length === 0) {
      alert("Please select at least one department");
      return;
    }

    try {
      setLoading(true);
      const { data } = await axios.put(
        `${server}/switchUsersList/updateById`,
        null,
        {
          // headers: { Authorization: `Bearer ${token}` },
          headers: { Authorization: `Bearer ${token}` },
          params: {
            accessibleDeptIds: selectedSwitchDepartments,
            departmentId: selectedDepartment?.id,
          },
          paramsSerializer: (params) => {
            return Object.keys(params)
              .map((key) => {
                if (Array.isArray(params[key])) {
                  return params[key]
                    .map((val) => `${key}=${encodeURIComponent(val)}`)
                    .join("&");
                }
                return `${key}=${encodeURIComponent(params[key])}`;
              })
              .join("&");
          },
        }
      );

      alert("Submitted successfully!");
    } catch (error) {
      console.log("Submit failed:", error);
      alert(error?.response?.data?.message || error?.response?.data);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSwitchUsersList();
  }, [selectedDepartment]);

  useEffect(() => {
    fetchDepartments();
  }, []);

  return (
    <div className="p-4">
      <div className="grid grid-cols-12">
        {/* Left Panel */}
        <div className="col-span-4 p-2">
          <h1>Departments / Users</h1>
          <input
            type="search"
            onChange={filterDepartment}
            placeholder="Search department"
            className="w-full border p-1 mb-2"
          />
          <div className="max-h-[80vh] overflow-y-auto border">
            {filteredAllDepartments?.map((item) => (
              <div
                onClick={() => setSelectedDepartment(item)}
                className={`${
                  item.id === selectedDepartment?.id
                    ? "bg-blue-400 text-white"
                    : "hover:bg-blue-100"
                } border-b px-2 py-1 cursor-pointer`}
                key={item.id}
              >
                {item?.departmentName}
              </div>
            ))}
          </div>
        </div>

        {/* Right Panel */}
        <div className="col-span-8 p-2">
          <h1 className="mb-2">User Details</h1>
          <table className="w-full text-sm border mb-4">
            <tbody>
              <tr>
                <td className="font-semibold w-1/3">Department</td>
                <td>{selectedDepartment?.departmentName}</td>
              </tr>
              <tr>
                <td className="font-semibold">Email</td>
                <td>{selectedDepartment?.userEmail}</td>
              </tr>
              <tr>
                <td className="font-semibold">User Name</td>
                <td>{selectedDepartment?.officerName}</td>
              </tr>
              <tr>
                <td className="font-semibold">Phone No</td>
                <td>{selectedDepartment?.phoneNo}</td>
              </tr>
              <tr>
                <td className="font-semibold">Office Address</td>
                <td>{selectedDepartment?.officeAddress}</td>
              </tr>
              <tr>
                <td className="font-semibold">Status</td>
                <td>{selectedDepartment?.status}</td>
              </tr>
            </tbody>
          </table>

          <h2 className="font-bold mb-2">
            Accessible Users List (Multi-select)
          </h2>
          <button
            onClick={submitSelectedDepartments}
            className="my-4 bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
          >
            Submit Selected Departments
          </button>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 h-[400px] overflow-hidden overflow-y-auto gap-2">
            {allDepartments?.map((dept) => {
              const isPreselected =
                switchUserData?.accessibleDepartmentsList?.some(
                  (d) => d.deptId === dept.id
                );

              const isChecked = selectedSwitchDepartments.includes(dept.id);

              return (
                <label
                  key={dept.id}
                  className={`border px-2 py-1 rounded cursor-pointer ${
                    isChecked ? "bg-blue-500 text-white" : "bg-gray-100"
                  }`}
                >
                  <input
                    name="dept"
                    type="checkbox"
                    className="mr-2"
                    checked={isChecked}
                    onChange={() => toggleSwitchDepartment(dept.id)}
                  />
                  {dept.departmentName}
                </label>
              );
            })}
          </div>
        </div>
      </div>

      {loading && <LoadingComponent />}
    </div>
  );
}
